window.jQuery = window.$ = require('jquery');
require('./thirdParty/bootstrap');
